(() => {
  const STORAGE_KEY = 'wildsoul_commission_attribution_v1';
  const MARKETING_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_campaign_id',
    'utm_adset',
    'utm_adset_id',
    'utm_content',
    'utm_ad_id',
    'utm_term',
  ];
  const PRIVATE_QUERY_KEY = /^(email|e-mail|name|first_?name|last_?name|full_?name|phone|mobile|address|ip|ip_?address|fbclid|gclid|msclkid|_ga|_fbp|_fbc)$/i;

  const safeUrl = (url, includeOrigin = false) => {
    const sanitized = new URL(url);
    const originalSearch = sanitized.search;
    let changed = false;

    for (const key of [...sanitized.searchParams.keys()]) {
      if (PRIVATE_QUERY_KEY.test(key)) {
        sanitized.searchParams.delete(key);
        changed = true;
      }
    }

    const path = sanitized.pathname + (changed ? sanitized.search : originalSearch);
    return (includeOrigin ? sanitized.origin : '') + path;
  };

  const externalReferrer = () => {
    if (!document.referrer) return '';

    try {
      const referrer = new URL(document.referrer);
      const host = referrer.hostname.toLowerCase();
      if (
        host === window.location.hostname.toLowerCase() ||
        host === 'wildsoulstudio.co' ||
        host === 'www.wildsoulstudio.co' ||
        host === 'utduin-9w.myshopify.com'
      ) return '';

      return safeUrl(referrer.href, true).slice(0, 2048);
    } catch (_error) {
      return '';
    }
  };

  const readStored = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
      return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
    } catch (_error) {
      return null;
    }
  };

  const capture = () => {
    const params = new URLSearchParams(window.location.search);
    const marketing = {};

    for (const key of MARKETING_KEYS) {
      const value = params.get(key)?.trim();
      if (value) marketing[key] = value.slice(0, 256);
    }

    const previous = readStored();
    if (!Object.keys(marketing).length && previous) return previous;

    const attribution = {
      ...marketing,
      entry_page: safeUrl(window.location.href).slice(0, 2048),
      external_referrer: externalReferrer(),
    };

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch (_error) {
      // Current-page values remain available even when storage is blocked.
    }

    return attribution;
  };

  const attribution = capture();

  const populateForm = () => {
    const requestType = document.querySelector(
      'input[name="contact[Request Type]"][value="WildSoul Studio Commission Request"]'
    );
    const form = requestType?.closest('form');
    if (!form) return;

    form.querySelectorAll('input[data-commission-attribution]').forEach((input) => {
      input.value = attribution[input.dataset.commissionAttribution] || '';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', populateForm, { once: true });
  } else {
    populateForm();
  }
})();
